const DEFAULT_EXTRA = {
    extremumThreshold: 2,
    bufferSize: 10,
};
export const bufferInterpolation = (currentBufferValue, array, value, extra) => {
    const { extremumThreshold = DEFAULT_EXTRA.extremumThreshold, bufferSize = DEFAULT_EXTRA.bufferSize, } = extra !== null && extra !== void 0 ? extra : DEFAULT_EXTRA;
    if (currentBufferValue < value) {
        let i = 0;
        while (i < extremumThreshold) {
            array.push(value);
            i++;
        }
    }
    else {
        array.push(value);
    }
    while (array.length >= bufferSize) {
        array.shift();
    }
    const l = array.length;
    let buffer = 0;
    for (let i = 0; i < l; i++) {
        buffer += array[i];
    }
    return Math.ceil(buffer / l);
};
